export default {
    currentUser: {},
    loading: false,
}